import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React, { useState, useRef, useEffect } from 'react';
import { iconSearch, iconPerson } from '@tesla/design-system-icons';
import { useMediaQuery, useTooltipState, Modal, ModalContent, FormInputDropdown, InternalHeader, InternalMenuTrigger, InternalLogo, AppSwitcher, Text, NavItem, Icon, TooltipWrapper, Tooltip, Sheet, SheetContent, SideNav } from '@tesla/design-system-react';
import { string, func, bool, shape, arrayOf, number } from 'prop-types';
import classnames from 'classnames';
import { parseJwt } from '../SearchBar/Helpers/Utilities.js';
import SearchBar from '../SearchBar/index.js';
import Notification from './Notification.js';
import RegionSelector from './RegionSelector/index.js';
import UserProfile from './UserProfile/index.js';
import styles from './styles.module.css.js';
import useGlobalSiteHeaderConfig from '../Hooks/useGlobalSiteHeaderConfig/index.js';

var _excluded = ["enableDropdown"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultTranslations = {
  signout: 'Sign Out',
  allCountries: 'All Countries',
  supportLink: 'Help & Support'
};

// Logout Urls Source of truth
// Doesn't change often, intent is to maximize control within the component
var LOGOUT_URL = 'https://login.microsoftonline.com/9026c5f4-86d0-4b9f-bd39-b7d4d0fb4674/oauth2/v2.0/logout';
var URL_MAP = {
  dev: LOGOUT_URL,
  stage: LOGOUT_URL,
  qa: LOGOUT_URL,
  prod: LOGOUT_URL
};
var Header = function Header(props) {
  var _userInfo$office, _userInfo$office$spli, _window, _window$location, _config$menu, _config$menu$regionSe, _config$menu2, _config$menu2$regionS, _config$menu3, _config$menu3$regionS;
  var t = props.t,
    id = props.id,
    aosUrl = props.aosUrl,
    appName = props.appName,
    clientId = props.clientId,
    propsAppTitle = props.appTitle,
    adfsToken = props.adfsToken,
    className = props.className,
    enableSearch = props.enableSearch,
    searchBarProps = props.searchBarProps,
    logoutCallback = props.logoutCallback,
    notificationUrl = props.notificationUrl,
    config = props.config,
    locale = props.locale,
    onClickSupportLink = props.onClickSupportLink,
    env = props.env;
  if (!env || !Object.keys(URL_MAP).includes(env)) {
    console.error("Please provide a valid envirionment ['dev', 'stage', 'qa', 'prod']");
    return null;
  }
  var logoutUrl = URL_MAP[env];
  var postLogoutUrl = window.location.origin;
  var _useMediaQuery = useMediaQuery(),
    isTabletPortraitUp = _useMediaQuery.isTabletPortraitUp,
    isTabletLandscapeUp = _useMediaQuery.isTabletLandscapeUp;
  var _useTooltipState = useTooltipState(),
    expanded = _useTooltipState.expanded,
    handlers = _useTooltipState.handlers,
    wrapperRef = _useTooltipState.wrapperRef;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSearch = _useState2[0],
    setShowSearch = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    openMobileMenu = _useState4[0],
    setOpenMobileMenu = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    menuOpen = _useState6[0],
    setMenuOpen = _useState6[1];
  var pathname = window.location.pathname;
  var userInfo = parseJwt(adfsToken);
  var userCountry = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$office = userInfo.office) === null || _userInfo$office === void 0 ? void 0 : (_userInfo$office$spli = _userInfo$office.split('-')) === null || _userInfo$office$spli === void 0 ? void 0 : _userInfo$office$spli[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    openRegionSelector = _useState8[0],
    setOpenRegionSelector = _useState8[1];
  var sheetRef = useRef();
  var internalMenuTriggerRef = useRef();
  var translation = _objectSpread(_objectSpread({}, defaultTranslations), t);
  var _ref = config || {},
    _ref$menuItems = _ref.menuItems,
    menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
    appSwitcherProps = _ref.appSwitcher,
    _ref$menuSheetClassNa = _ref.menuSheetClassName,
    menuSheetClassName = _ref$menuSheetClassNa === void 0 ? '' : _ref$menuSheetClassNa,
    _ref$dropdownProps = _ref.dropdownProps,
    dropdownProps = _ref$dropdownProps === void 0 ? {} : _ref$dropdownProps;
  dropdownProps.enableDropdown;
    var dropDownDomProps = _objectWithoutProperties(dropdownProps, _excluded);
  var appTitle = (appSwitcherProps === null || appSwitcherProps === void 0 ? void 0 : appSwitcherProps.title) || propsAppTitle;
  var _useGlobalSiteHeaderC = useGlobalSiteHeaderConfig({
      osAccessToken: adfsToken,
      aosUrl: aosUrl,
      locale: locale,
      appName: appTitle,
      appSwitcherProps: appSwitcherProps
    }),
    showAppSwitcher = _useGlobalSiteHeaderC.show,
    loadingHeaderConfig = _useGlobalSiteHeaderC.loading,
    appSwitcherConfig = _useGlobalSiteHeaderC.appSwitcherConfig;
  var homePageUrl = "".concat((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin).concat(locale ? "/".concat(locale) : '', "/account");
  if (appTitle.toUpperCase() === 'COMMUNICATIONS') {
    var _window2, _window2$location;
    homePageUrl = "".concat((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.origin).concat(locale ? "/".concat(locale) : '', "/communications");
  } else if (appTitle.toUpperCase() === 'VEHICLE ORDERS') {
    var _window3, _window3$location;
    homePageUrl = "".concat((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : _window3$location.origin, "/vehicle-order");
  }
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (sheetRef.current && !sheetRef.current.contains(event.target) && !internalMenuTriggerRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return function () {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  useEffect(function () {
    setShowSearch(!['/', '/account', '/404', '/500', '/account/api-doc', '/account/auth/callback'].includes(pathname));
  }, [pathname]);
  var handleLogout = function handleLogout() {
    var authEndPointWithParams = new URL(logoutUrl);
    authEndPointWithParams.searchParams.append('client_id', clientId);
    authEndPointWithParams.searchParams.append('id_token_hint', adfsToken);
    authEndPointWithParams.searchParams.append('post_logout_redirect_uri', postLogoutUrl);
    localStorage.clear();
    logoutCallback();
    setTimeout(function () {
      return window.open(authEndPointWithParams, '_self');
    }, 100);
  };
  var searchBar = /*#__PURE__*/React.createElement(SearchBar, _extends({
    id: "header_searchbar_".concat(id),
    searchCount: 3,
    embedded: true,
    appName: appName,
    adfsToken: adfsToken,
    aosUrl: aosUrl,
    locale: locale,
    enableScope: true,
    dense: true
  }, searchBarProps, {
    className: classnames(searchBarProps === null || searchBarProps === void 0 ? void 0 : searchBarProps.className, styles['site-header-search-bar'])
  }));
  var modalMenu = /*#__PURE__*/React.createElement(Modal, {
    className: classnames(styles['no-scroll'], 'tds-site-header-modal tds-modal--sheet-medium tds-scrim--white'),
    onClose: function onClose() {
      return setOpenMobileMenu(false);
    },
    open: openMobileMenu,
    variant: "sheet-right"
  }, /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement("div", {
    className: styles['site-header-menu-modal-layout']
  }, showSearch && enableSearch ? searchBar : null, /*#__PURE__*/React.createElement("div", {
    className: styles['site-header-menu-modal-dropdown']
  }, !isTabletLandscapeUp && (dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.enableDropdown) && /*#__PURE__*/React.createElement(FormInputDropdown, _extends({
    variant: "inline",
    className: "tds-density--default",
    tooltipProps: {
      align: 'end'
    }
  }, dropDownDomProps))))));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InternalHeader, {
    className: classnames(styles['site-header'], className),
    leading: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      ref: internalMenuTriggerRef,
      id: "tw-react--site-header--side-nav-container"
    }, menuItems && menuItems.length > 0 && /*#__PURE__*/React.createElement(InternalMenuTrigger, {
      onClick: function onClick() {
        return setMenuOpen(!menuOpen);
      }
    })), /*#__PURE__*/React.createElement(InternalLogo, {
      href: homePageUrl
    }), showAppSwitcher && !loadingHeaderConfig ? /*#__PURE__*/React.createElement(AppSwitcher, {
      appTitle: appTitle,
      apps: appSwitcherConfig.applications
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      is: "p",
      className: styles['header-divider']
    }, "|"), /*#__PURE__*/React.createElement(NavItem, {
      leadingText: appTitle,
      readOnly: true,
      className: styles['site-header-app-switcher--static']
    }))),
    search: isTabletPortraitUp && showSearch && enableSearch ? searchBar : null,
    trailing: /*#__PURE__*/React.createElement(React.Fragment, null, !isTabletPortraitUp && showSearch && enableSearch && /*#__PURE__*/React.createElement(NavItem, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        data: iconSearch,
        onClick: function onClick() {
          return setOpenMobileMenu(true);
        }
      })
    }), isTabletLandscapeUp && (dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.enableDropdown) && /*#__PURE__*/React.createElement(FormInputDropdown, _extends({
      variant: "inline",
      className: "tds-density--default",
      tooltipProps: {
        align: 'end'
      }
    }, dropDownDomProps)), adfsToken ? /*#__PURE__*/React.createElement(Notification, {
      url: notificationUrl,
      token: adfsToken,
      xChannel: "desktop, ipad",
      xApp: appName
    }) : null, /*#__PURE__*/React.createElement(TooltipWrapper, _extends({}, handlers, {
      wrapperRef: wrapperRef,
      inline: true
    }), /*#__PURE__*/React.createElement(NavItem, {
      startIcon: /*#__PURE__*/React.createElement(Icon, {
        data: iconPerson
      }),
      id: "tw-react--site-header--user-profile--user-icon"
    }), /*#__PURE__*/React.createElement(Tooltip, {
      open: expanded,
      dense: true,
      align: "end"
    }, /*#__PURE__*/React.createElement(UserProfile, {
      osAccessToken: adfsToken,
      logout: {
        title: translation.signout,
        onClick: handleLogout
      },
      supportLink: {
        title: translation.supportLink,
        onClick: onClickSupportLink
      },
      regionSelector: {
        show: !(config !== null && config !== void 0 && (_config$menu = config.menu) !== null && _config$menu !== void 0 && (_config$menu$regionSe = _config$menu.regionSelector) !== null && _config$menu$regionSe !== void 0 && _config$menu$regionSe.disabled),
        onClick: function onClick() {
          return setOpenRegionSelector(true);
        },
        selectedRegion: config === null || config === void 0 ? void 0 : (_config$menu2 = config.menu) === null || _config$menu2 === void 0 ? void 0 : (_config$menu2$regionS = _config$menu2.regionSelector) === null || _config$menu2$regionS === void 0 ? void 0 : _config$menu2$regionS.selectedRegion
      }
    }))))
  }), /*#__PURE__*/React.createElement("div", {
    ref: sheetRef
  }, /*#__PURE__*/React.createElement(Sheet, {
    align: "left",
    onClose: function onClose() {
      return setMenuOpen(false);
    },
    open: menuOpen,
    modal: false,
    className: classnames(styles['menu-sheet'], _defineProperty({}, styles['menu-sheet--mobile'], !isTabletLandscapeUp), menuSheetClassName),
    id: "header-menu-sidesheet"
  }, /*#__PURE__*/React.createElement(SheetContent, null, /*#__PURE__*/React.createElement(SideNav, {
    items: menuItems,
    collapsed: !menuOpen,
    className: styles['side-nav-v9']
  })))), modalMenu, /*#__PURE__*/React.createElement(RegionSelector, {
    t: translation,
    userCountry: userCountry,
    open: openRegionSelector,
    onClose: function onClose() {
      return setOpenRegionSelector(false);
    },
    selectedRegion: config === null || config === void 0 ? void 0 : (_config$menu3 = config.menu) === null || _config$menu3 === void 0 ? void 0 : (_config$menu3$regionS = _config$menu3.regionSelector) === null || _config$menu3$regionS === void 0 ? void 0 : _config$menu3$regionS.selectedRegion,
    onSelectRegion: function onSelectRegion(e) {
      var _config$menu4, _config$menu4$regionS;
      setOpenRegionSelector(false);
      config === null || config === void 0 ? void 0 : (_config$menu4 = config.menu) === null || _config$menu4 === void 0 ? void 0 : (_config$menu4$regionS = _config$menu4.regionSelector) === null || _config$menu4$regionS === void 0 ? void 0 : _config$menu4$regionS.onSelectRegion(e);
    }
  }), /*#__PURE__*/React.createElement("style", null, ".tds-chip--open {\n              padding: 0;\n            }"));
};
Header.defaultProps = {
  adfsToken: '',
  className: '',
  supportUrl: '',
  appTitle: '',
  enableSearch: true,
  searchBarProps: {},
  onClickSupportLink: undefined,
  logoutCallback: function logoutCallback() {},
  locale: null,
  t: {
    signout: 'Sign Out',
    allCountries: 'All Countries',
    supportLink: 'Help & Support'
  },
  config: {
    menu: {
      regionSelector: {
        disabled: false,
        selectedRegion: 'North America',
        onSelectRegion: function onSelectRegion() {}
      }
    },
    menuItems: [],
    appSwitcher: {},
    menuSheetClassName: ''
  },
  env: ''
};
Header.propTypes = {
  id: string.isRequired,
  className: string,
  adfsToken: string,
  locale: string,
  appTitle: string,
  onClickSupportLink: func,
  notificationUrl: string.isRequired,
  appName: string.isRequired,
  supportUrl: string,
  clientId: string.isRequired,
  aosUrl: string.isRequired,
  enableSearch: bool,
  logoutCallback: func,
  t: shape({
    signout: string,
    allCountries: string,
    supportLink: string
  }),
  config: shape({
    menu: shape({
      regionSelector: shape({
        disabled: bool,
        label: string,
        selectedRegion: string,
        onSelectRegion: func
      })
    }),
    menuItems: arrayOf(shape({
      href: string,
      id: string,
      leadingText: string,
      items: arrayOf(shape({
        href: string,
        id: string,
        leadingText: string
      }))
    })),
    dropdownConfig: shape({
      enableDropdown: bool,
      options: arrayOf(string),
      selected: string,
      onOptionSelect: func
    }),
    appSwitcher: shape({
      show: bool,
      title: string,
      applications: arrayOf(string)
    }),
    menuSheetClassName: string
  }),
  searchBarProps: shape({
    placeholder: string,
    recent: string,
    embedded: bool,
    searchCount: number,
    value: string.isRequired,
    onChange: func
  }),
  env: string
};

export { Header as default };
